import React, { Component } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import moment from "moment";

//componentes
import "./fechaPlanificacion.css";
import Alert from "../../modal/alert";

class FechaPlanificacion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      idcurso: "",
      tipoPlanifi: "",
      fecha: "",
      anoEscolar: "",
      tipoPlani: "",
      icursos: [],
      iprofesorA: [],
      ianoEscolar: [],
      tipoPlanif: [],
      listaOn: false,

      verplanillaOn: false,
    };
  }

  limpiar = () => {
    this.setState({
      idprofesor: "",
      tipoPlanifi: "",
      fecha: "",
      listaOn: false,
    });
  };
  onChange(e) {
    //console.log(e.target.name)
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  onChange2(e) {
    //console.log(e.target.name)
    this.setState({
      [e.target.name]: e.target.value,
    });
    this.buscarFP(e.target.value);
  }

  guardar = () => {
    if (
      this.state.idcurso.length > 0 &&
      this.state.tipoPlanifi.length > 0 &&
      this.state.anoEscolar.length > 0 &&
      this.state.tipoPlani.length > 0
    ) {
      let data = new FormData();
      data.append("idcurso", this.state.idcurso);
      data.append("descripcion", this.state.tipoPlanifi);
      data.append("tipoPlani", this.state.tipoPlani);
      data.append("anoEscolar", this.state.anoEscolar);
      data.append("boton", "guardarFP");

      let config = {
        headers: {
          "Content-Type": "text/html",
        },
      };
      const xurl =
        "https://institutobilinguelasnaciones.com/terapiasprueba/backend/fechaPlanificacion.php";
      axios
        .post(xurl, data, config)

        .then((res) => {
          if (res.data.variable1) {
            this.buscarFP(this.state.anoEscolar);
            this.setState({
              mensajealerta: true,
              tituloM: "Menu Planificar por Fecha.",
              cuerpoM: res.data.variable2,
              idcurso: "",
            });
          } else {
            this.setState({
              mensajealerta: true,
              tituloM: "Menu Planificar por Fecha.",
              cuerpoM: res.data.variable2,
            });
          }
        });
    } else {
      this.setState({
        mensajealerta: true,
        tituloM: "Menu Planificar por Fecha.",
        cuerpoM:
          "Debe seleccionar Año Escolar, Grado, colocar una Fecha y el Titulo de la Planificacion.",
      });
    }
  };

  eliminar = (e) => {
    if (parseFloat(e) > 0) {
      let data = new FormData();
      data.append("idfechaPlanificacion", e);
      data.append("boton", "eliminarFP");

      let config = {
        headers: {
          "Content-Type": "text/html",
        },
      };
      const xurl =
        "https://institutobilinguelasnaciones.com/terapiasprueba/backend/fechaPlanificacion.php";
      axios.post(xurl, data, config).then((res) => {
        if (res.data.variable1) {
          this.setState({
            mensajealerta: true,
            tituloM: "Menu Autorizar Profesor para Planificar.",
            cuerpoM: res.data.variable2,
          });
          this.buscarFP(this.state.anoEscolar);
        } else {
          this.setState({
            mensajealerta: true,
            tituloM: "Menu Autorizar Profesor para Planificar.",
            cuerpoM: res.data.variable2,
          });
        }
      });
    } else {
      this.setState({
        mensajealerta: true,
        tituloM: "Menu Autorizar Profesor para Planificar.",
        cuerpoM: "Debe existir un registro para poder eliminarlo.",
      });
    }
  };

  handleClose = () => {
    this.setState({ mensajealerta: false });
  };

  buscarFP = (e) => {
    let form = new FormData();
    form.append("anoEscolar", e);
    form.append("boton", "buscarFP");
    let config = {
      headers: { "Content-Type": "text/html" },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapiasprueba/backend/fechaPlanificacion.php";
    axios.post(xurl, form, config).then((res) => {
      let xiprofesorA = res.data.variable2;
      this.setState({
        iprofesorA: xiprofesorA,
      });
    });
  };

  buscarTP = (e) => {
    let form = new FormData();
    form.append("boton", "buscarTipoP");
    let config = {
      headers: { "Content-Type": "text/html" },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapiasprueba/backend/fechaPlanificacion.php";
    axios.post(xurl, form, config).then((res) => {
      let xitipoP = res.data.variable2;
      this.setState({
        tipoPlanif: xitipoP,
      });
    });
  };

  buscarSalones = () => {
    let data = new FormData();
    data.append("boton", "buscarSalones");

    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl = "https://institutobilinguelasnaciones.com/terapiasprueba/backend/materia.php";
    axios
      .post(xurl, data, config)

      .then((res) => {
        let xicursos = res.data.variable2;

        this.setState({
          icursos: xicursos,
        });
      });
  };

  buscarAnioEscolar = () => {
    let data = new FormData();
    data.append("boton", "buscarAnioEscolar");
    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapiasprueba/backend/maternal.php";
    axios.post(xurl, data, config).then((res) => {
      if (res.data.variable1) {
        this.setState({
          //anoEscolar: res.data.variable2,
          ianoEscolar: res.data.variable3,
        });
      }
    });
  };

  componentDidMount() {
    this.buscarAnioEscolar();
    this.buscarSalones();
    this.buscarTP();
  }

  render() {
    return (
      <div className="principal-pago row">
        <div className="contenedor-cxc col-12">
          <div className="titulo-cxc ">
            <p>CREAR FECHA Y TITULO DE PLANIFICACION. </p>
          </div>
          {this.state.mensajealerta === true && (
            <Alert
              tituloMensaje={this.state.tituloM}
              cuerpoMensaje={this.state.cuerpoM}
              open={this.state.mensajealerta}
              handleClose={this.handleClose}
            />
          )}
          <div className="cont-listmedi row">
            <div className="cont-personal col-12">
              <div className="contenedorcedula1f col-2">
                <select
                  id="anoEscolar"
                  name="anoEscolar"
                  value={this.state.anoEscolar}
                  onChange={this.onChange2.bind(this)}
                >
                  <option>-- Año Escolar --</option>
                  {this.state.ianoEscolar.map((item, i) => {
                    return (
                      <option key={i} value={item.variable1}>
                        {item.variable1}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="contenedorcedula1f col-3">
                <select
                  id="idcurso"
                  name="idcurso"
                  value={this.state.idcurso}
                  onChange={this.onChange.bind(this)}
                >
                  <option>-- Seleccionar Grado --</option>
                  {this.state.icursos.map((item, i) => {
                    return (
                      <option key={i} value={item.variable1}>
                        {item.variable2}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="contenedorcedula1f col-3">
                <select
                  id="tipoPlani"
                  name="tipoPlani"
                  value={this.state.tipoPlani}
                  onChange={this.onChange.bind(this)}
                >
                  <option>-- Tipo de Planificacion --</option>
                  <option value="1">Semanal</option>
                  <option value="2">Mensual</option>
                </select>
              </div>
              <div className="contenedorcedula1f col-4">
                <select
                  id="tipoPlanifi"
                  name="tipoPlanifi"
                  value={this.state.tipoPlanifi}
                  onChange={this.onChange.bind(this)}
                >
                  <option>-- Titulo de Planificacion --</option>
                  {this.state.tipoPlanif.map((item, i) => {
                    return (
                      <option key={i} value={item.variable1}>
                        {item.variable2}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
            <div className="xcontenedorcedula1x col-12">
              <button className="boton" onClick={this.guardar.bind(this)}>
                Agregar
              </button>
              <Link to="/">
                <button className="boton">Salir</button>
              </Link>
            </div>
          </div>

          <div className="cont-listmedix row">
            <div className="listcxcx col-12">
              <table className="tablacxcx" border="1">
                <thead>
                  <tr>
                    <th className="titucxc1">GRADO</th>
                    <th className="titucxc1">FECHA Y PLANIFICACION</th>
                    <th className="titucxc3x">
                      <span className="titulo-eliminar">
                        <span className="cerrarme3"></span>
                      </span>
                    </th>
                  </tr>
                </thead>

                {this.state.iprofesorA.map((item, i) => {
                  return (
                    <tr
                      className={i % 2 === 0 ? "odd" : "odd"}
                      key={item.variable1}
                      id="tabla"
                    >
                      <td className="totalescxcx">{item.variable2}</td>
                      <td className="totalescxcx">{item.variable3}</td>
                      <td className="xcerr">
                        <span
                          className="cerrarme1"
                          onClick={this.eliminar.bind(this, item.variable1)}
                        ></span>{" "}
                      </td>
                    </tr>
                  );
                })}
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default FechaPlanificacion;
